export const makeDataObjGenerator =
  <T>(defaultData: T) =>
  <U extends Partial<T>>(data?: U) =>
    ({
      ...defaultData,
      ...(data || {}),
    } as T & U)
